import { ArgsType, Field, Int } from '@nestjs/graphql'
import { BaseCreateDto } from '../../base/baseCreate.dto'

@ArgsType()
export class CreateUserStatusDto extends BaseCreateDto<CreateUserStatusDto> {
  @Field(t => Int)
  userId!: number

  @Field(t => Int)
  type!: number

  @Field()
  active!: boolean

  @Field()
  isRestriction!: boolean

  @Field({ nullable: true })
  additionalInformation?: string

  @Field({ nullable: true })
  expiryDate?: Date

  @Field(t => Int, { nullable: true })
  ineligibleReason?: number
}
